import React from 'react';
import classNames from 'classnames/bind.js';
import proptypes from 'prop-types';
const { string, shape, oneOfType } = proptypes;

import { Image } from '@thd-olt-component-react/core-ui';

import styles from './info-card.module.scss';

const cx = classNames.bind(styles);

export const InfoCard = ({ infoType, mainHeader, subHeader }) => {
  function iconSwitch(icon) {
    switch (icon) {
    case 'ProfileInfo':
      return (
        <Image
          asset="profile-darkGray.svg"
          height={35}
          width={35}
          title="Profile Icon"
          alt="Profile Icon"
        />
      );
    case 'LicenseInfo':
      return (
        <Image
          asset="valid-id-icon-darkGray.svg"
          height={35}
          width={35}
          title="License Icon"
          alt="License Icon"
        />
      );
    case 'ClearInfo':
      return (
        <Image
          asset="brand-logos/CLEAR_Logo.svg"
          height={35}
          width={35}
          title="CLEAR Icon"
          alt="CLEAR Icon"
        />
      );
    default: return (<></>);
    }
  }

  return (
    <div className={cx('info-card', 'info-card__success')}>
      <div className={cx('info-card__icon')}>
        {iconSwitch(infoType)}
      </div>
      <div className={cx('info-card__content')}>
        <div className={cx('info-card__content__header')}>
          {mainHeader}
        </div>
        <div className={cx('info-card__content__sub-header')}>
          {subHeader}
        </div>
      </div>
    </div>
  );
};

InfoCard.displayName = 'InfoCard';

InfoCard.propTypes = {
  infoType: string.isRequired,
  mainHeader: string,
  subHeader: oneOfType([string, shape({})])
};

InfoCard.defaultProps = {
  mainHeader: '',
  subHeader: ''
};
